module.exports = __webpack_public_path__ + "img/OX.dedc08ea.svg";